// 处理后端返回的标签字符串解决样式污染问题
export const shadowDom = (eleId, htmlContent) => {
    const ele = document.getElementById(eleId)
    if (ele) {
        ele.attachShadow = ele.attachShadow || ele.webkitAttachShadow || ele.mozAttachShadow
        const shadowRoot = ele.attachShadow({ mode: 'open' })
        shadowRoot.innerHTML = htmlContent
    }
    return ''
}